import clsx from "clsx";
import type { HTMLAttributes } from "react";
import type React from "react";
import styles from "./tab.module.scss";

export type TabProps<T> = (
  | {
      label: string;
      children?: never;
    }
  | {
      label?: never;
      children: T;
    }
) &
  Omit<HTMLAttributes<HTMLDivElement>, "children" | "id"> & {
    isActive?: boolean;
    id?: number;
    classes?: {
      active?: string;
    };
  };

function Tab<T extends React.ReactNode>(props: TabProps<T>) {
  const { label, children, isActive, className, id, classes, ...rest } = props;
  return (
    <div
      {...rest}
      className={clsx(
        styles["tab"],
        isActive && styles["tab--active"],
        isActive && classes?.active,
        className
      )}
    >
      {label || children}
    </div>
  );
}

export default Tab;
